import { authClient } from "./apiClient";

const loginApi = async (data) => {
  data["device"] = "leitnerpwa";
  return await authClient.post("/api/v1/auth/login/", data);
};

const loginLeitnerpwaApi = async (token) => {
  return await authClient.post(
    "/api/v1/auth/login/loginleitnerpwa",
    {},
    { headers: { authorization: `bearer ${token}` } }
  );
};

const RegisterStepOneApi = async (data) => {
  let phoneCode = data["phoneNumber"].slice(0, 2);
  let userIp = null;
  if (phoneCode !== "98") {
    let getIpUser = await fetch("https://api.ipify.org?format=json");
    let info = await getIpUser.json();
    userIp = info.ip;
  }
  data["userIp"] = userIp;
  return authClient.post("/api/v1/auth/register/step1", data);
};

const RegisterStepTwoApi = (data) => {
  data["device"] = "web";
  return authClient.post("/api/v1/auth/register/step2", data);
};

const setPasswordApi = async (data) => {
  return await authClient.post("/api/v1/auth/register/step3", data);
};

const changePasswordApi = async (data) => {
  return await authClient.post("/api/v1/auth/register/changepassword", data);
};

const setReferralCodeApi = async (data) => {
  return await authClient.post("/api/v1/auth/register/setReferralCode", data);
};

const loginCodeStep1Api = async (data) => {
  let phoneCode = data["phoneNumber"].slice(0, 2);
  let userIp = null;
  if (phoneCode !== "98") {
    let getIpUser = await fetch("https://api.ipify.org?format=json");
    let info = await getIpUser.json();
    userIp = info.ip;
  }
  data["userIp"] = userIp;
  return authClient.post("/api/v1/auth/login/codestep1", data);
};

const loginCodeStep2Api = (data) => {
  data["device"] = "web";
  return authClient.post("/api/v1/auth/login/codestep2", data);
};

const getAuthUserinfoApi = async (data) => {
  return await authClient.post("/api/v1/auth/register/userinfo", data);
};

const changeInvalidPhonenumberApi = async (data) => {
  let phoneCode = data["phoneNumber"].slice(0, 2);
  let userIp = null;
  if (phoneCode !== "98") {
    let getIpUser = await fetch("https://api.ipify.org?format=json");
    let info = await getIpUser.json();
    userIp = info.ip;
  }
  data["userIp"] = userIp;
  return authClient.post("/api/v1/auth/register/changeInvalidPhonenumber", data);
};

const ChangeUserNameApi = async (data) => {
  return await authClient.post("/api/v1/auth/register/changeusername", data);
};

const checkUsernameValidApi = async (data) => {
  return await authClient.post("/api/v1/auth/register/checkusernamevalid", data);
};

const getfreetrialApi = async (data) => {
  return await authClient.post("/api/v1/auth/register/getfreetrial", data);
};

const addgmailApi = async (data) => {
  return await authClient.post("/api/v1/auth/register/addgmail", data);
};

const requestoauthApi = async (data) => {
  data["device"] = "web";
  return authClient.post("/api/v1/auth/register/requestoauth", data);
};

const getregistertokenApi = async (data) => {
  data["device"] = "web";
  return authClient.post("/api/v1/auth/login/getregistertoken", data, {
    headers: { authorization: `bearer ${data["rtoken"]}` },
  });
};

const getfreetrialallApi = async (data) => {
  return await authClient.post("/api/v1/auth/register/getfreetrialall", data);
};

const getforumtokenApi = async () => {
  return await authClient.post("/api/v1/auth/login/getforumtoken", {});
};

const removeforumtokenApi = async () => {
  return await authClient.post("/api/v1/auth/login/removeforumtoken", {});
};

export {
  loginApi,
  RegisterStepOneApi,
  RegisterStepTwoApi,
  setPasswordApi,
  setReferralCodeApi,
  loginCodeStep1Api,
  loginCodeStep2Api,
  getAuthUserinfoApi,
  checkUsernameValidApi,
  ChangeUserNameApi,
  changePasswordApi,
  getfreetrialApi,
  requestoauthApi,
  getregistertokenApi,
  addgmailApi,
  changeInvalidPhonenumberApi,
  getfreetrialallApi,
  getforumtokenApi,
  removeforumtokenApi,
  loginLeitnerpwaApi,
};
